<template>
    <div class="orders">
        <!-- 头部菜单 -->
        <Header></Header>
        <div class="main" >
            <img src="@/assets/images/school/shadow.jpg" alt="">
            <div class="info1">
                <div class="f1" style="padding-top: 0;">
                    <p class="p1">Core Strengths</p>
                    <p class="p2">10大核心竞争力</p>
                </div>
                <ul>
                    <li style="width: 48%">
                        <div>
                            <p>50000平方米仓储物流中心</p>
                            <span>为客户提供无忧的货品供给，3.9亿库存</span>
                        </div>
                        <img src="@/assets/images/addvantage/1.jpg" alt="">
                    </li>
                    <li style="width: 48%">
                        <div>
                            <p>1000家优质产品供应商</p>
                            <span>50%合作5年以上的优质供应商，产品质量是企业的生命线</span>
                        </div>
                        <img src="@/assets/images/addvantage/2.jpg" alt="">
                    </li>
                    <li>
                        <div>
                            <p>10年行业沉淀</p>
                            <span>大数据基础、团队基础、供应链基础</span>
                        </div>
                        <img src="@/assets/images/addvantage/3.jpg" alt="">
                    </li>
                    <li>
                        <div>
                            <p>二店率高达38%</p>
                            <span>老加盟商开2店或多店超过400家</span>
                        </div>
                        <img src="@/assets/images/addvantage/4.jpg" alt="">
                    </li>
                    <li>
                        <div>
                            <p>双总部运营，2个分公司，1个仓储物流中心</p>
                            <span>服务范围覆盖全国，平均每季度下店服务超过900家店</span>
                        </div>
                        <img src="@/assets/images/addvantage/5.jpg" alt="">
                    </li>
                    <li style="width: 48%">
                        <div>
                            <p>全年度12场商学院培训会</p>
                            <span>行业人才孵化器，全国巡回培训</span>
                        </div>
                        <img src="@/assets/images/addvantage/6.jpg" alt="">
                    </li>
                    <li style="width: 48%">
                        <div>
                            <p>军事化管理团队</p>
                            <span>作风过硬，保障有力，超强执行力团队</span>
                        </div>
                        <img src="@/assets/images/addvantage/7.jpg" alt="">
                    </li>
                    <li>
                        <div>
                            <p>供应链</p>
                            <span>6000款SKU，百分百全系列定制产品，品质有保证，首批货品百分百调换货政策</span>
                        </div>
                        <img src="@/assets/images/addvantage/201.jpg" alt="">
                    </li>
                    <li style="width: 49%">
                        <div>
                            <p>整店输出</p>
                            <span>选址、开店、货品供给、督导下店，全程持续服务，让加盟商开店无忧</span>
                        </div>
                        <img src="@/assets/images/addvantage/21.jpg" alt="">
                    </li>
                    <li style="width: 49%">
                        <div>
                            <p>天下武功，唯快不破</p>
                            <span>平均每个月800款新品的速度，同行业的标杆</span>
                        </div>
                        <img src="@/assets/images/addvantage/22.jpg" alt="">
                    </li>
                </ul>
                <img src="@/assets/images/addvantage/8.png" alt="">
                <img src="@/assets/images/addvantage/10.jpg" alt="">
                <img src="@/assets/images/addvantage/11.jpg" alt="">
            </div>
            <div class="info2">
                <div class="f1">
                    <p class="p1">Support System</p>
                    <p class="p2">八大支持体系</p>
                </div>
                <p class="t">从找店面到落地运营，全方位嵌入支持</p>
                <ul>
                    
                    <li>
                        <p>店面选址</p>
                        <span>商圈顾客评估优选最佳开店地址</span>
                    </li>
                    <li>
                        <p>整店VI装修</p>
                        <span>提供整体VI把控 店面图纸设计</span>
                    </li>
                    <li>
                        <p>智能ERP系统</p>
                        <span>海鼎ESHOP智能ERP收银软件</span>
                    </li>
                    <li>
                        <p>运营筹备</p>
                        <span>定期组织培训 提供系统培训支持</span>
                    </li>
                    <li>
                        <p>熙美诚品</p>
                        <span>成就加盟商</span>
                    </li>
                    <li>
                        <p>每月商学院</p>
                        <span>定期组织培训 提供系统培训支持</span>
                    </li>
                    <li>
                        <p>高级督导</p>
                        <span>专业运营导师 下店指导</span>
                    </li>
                    <li>
                        <p>宣传推广</p>
                        <span>定期组织培训 提供系统培训支持</span>
                    </li>
                    <li>
                        <p>日常运营</p>
                        <span>定期组织培训 提供系统培训支持</span>
                    </li>
                    <li style="background: none;"></li>
                </ul>
                <img src="@/assets/images/addvantage/12.jpg" alt="">

            </div>
            <div class="info3">
                <div class="f1">
                    <p class="p1">Return On Investment</p>
                    <p class="p2">投资回报</p>
                </div>
                <div class="ximei">
                    <img src="@/assets/images/addvantage/19.jpg" alt="">
                    <p style="text-indent: 2em; text-align:justify; text-justify:distribute-all-lines;">目前，熙美诚品平均每1天就有2家熙美诚品店开业。熙美诚品对所有门店营业额进行数据分析，得出60平方米的门店平均营业额，每天
                        5000元左右；100平方米的门店平均营业额，每天8000元左右；150平方米的门店平均营业额，每天一万元左右。
                    </p>
                </div>
                <div class="path">
                    <img src="@/assets/images/addvantage/20.jpg" alt="">
                    <div class="f1" style="padding-top: 0;">
                        <p class="p1">Join Process</p>
                        <p class="p2">加盟流程</p>
                    </div>
                    <img src="@/assets/images/addvantage/15.jpg" alt="">
                    <!-- <div style="display: flex;">
                        <img src="@/assets/images/addvantage/16.jpg" alt="" style="width: 50%;height: 50%;">
                        <img src="@/assets/images/addvantage/17.jpg" alt="" style="width: 50%;height: 50%;"> 
                    </div> -->
                </div>
            </div>
            <div class="info4">
                <div class="f1" style="background:#fff;">
                    <p class="p1">Open for Business</p>
                    <p class="p2">开店启动周期分布</p>
                </div>
                <img src="@/assets/images/addvantage/18.png" alt="">
                <ul class="item">
                    <li v-for="(item,index) in iconList" :key="index" :class="{'active':value === item.index}" @click="method(item.index)">
                        <span :class="item.icon" class="iconfont"></span>
                        <p style="margin-bottom: 15px;">{{item.label}}</p>
                        <p style="width: 90px;margin-left: -10px;color:#495060;">{{item.text}}</p>
                    </li>
                </ul>
                <ul class="item-content" v-show="value=='1'">
                    <li>
                        <span>01</span>
                        <p>店面选址</p>
                    </li>
                    <li>
                        <span>02</span>
                        <p>根据当地商圈店面评估，人流量测试 </p>
                    </li>
                    
                    <!-- <li>
                        <span>03</span>
                        <p>为加盟商寻找店面 </p>
                    </li> -->
                </ul>
                <ul class="item-content" v-show="value=='2'">
                    <!-- <p style="padding-left: 15px;">1个月内</p> -->
                    <li>
                        <span>01</span>
                        <p>施工 店铺工程指导</p>
                    </li>
                    <li>
                        <span>02</span>
                        <p>效果图设计</p>
                    </li>
                    <li>
                        <span>03</span>
                        <p>督导下店支持</p>
                    </li>
                    <li>
                        <span>04</span>
                        <p>宣传推广支持</p>
                    </li>
                </ul>
                <ul class="item-content" v-show="value=='3'">
                    <!-- <p style="padding-left: 15px;">3-6个月</p> -->
                    <li>
                        <span>01</span>
                        <p>运营指导</p>
                    </li>
                    <li>
                        <span>02</span>
                        <p>区域宣传推广</p>
                    </li>
                    <li>
                        <span>03</span>
                        <p>集中培训、复训</p>
                    </li>
                    <!-- <li>
                        <span>04</span>
                        <p>店面运营支持</p>
                    </li> -->
                </ul>
                <ul class="item-content" v-show="value=='4'">
                    <!-- <p style="padding-left: 15px;">6个月之后</p> -->
                    <li>
                        <span>01</span>
                        <p>日常运营管理支持</p>
                    </li>
                    <li>
                        <span>02</span>
                        <p>定期强化培训支持</p>
                    </li>
                    <li>
                        <span>03</span>
                        <p>品牌宣传推广支持 </p>
                    </li>
                </ul>
            </div>
        </div>
        <BackTop :bottom="50" :right="10">
            <div class="top"><span class="iconfont">&#xe63f;</span></div>
        </BackTop>
        <!-- 底部内容 -->
        <Footer v-show="show"></Footer>
        <!-- <Msg></Msg> -->
    </div>
</template>
<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import Msg from '@/components/msg.vue'
export default {
    data(){
        return {
            show:false,
            iconList:[
                {index:'1',label:'筹备期' ,icon:'el-iconchoubeijieduan',text:''},
                {index:'2',label:'开业前',icon:'el-iconchoubeijihua',text:'（1个月内）'},
                {index:'3',label:'发展期',icon:'el-iconfazhan',text:'（3-6个月）'},
                {index:'4',label:'稳定期',icon:'el-iconwendingxing',text:'（6个月之后）'},
            ],
            value:'1',
        }
    },
    components: {
        Header,
        Footer,
        Msg
    },
    created () {
        const that = this
        that.timer = setInterval(function () {
            if (document.readyState === 'complete') {
               that.show=true;
                window.clearInterval(that.timer)
            }
        }, 1000)
    },
    methods:{
        method(index){
            this.value=index;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/orders.vue